<template>
  <div>
    <b-modal
      id="modal-owners-digital-application"
      size="lg"
      centered
      :hide-footer="true"
      ref="ownersModal"
    >
      <template #modal-title>
        <div class="magenta-title">Gesuch an Eigentümer weiterleiten</div>
      </template>
      <div>
        <b-alert v-model="hasUnknownError" variant="danger">
          {{ unknownErrorMessage }}
        </b-alert>
        <b-alert v-model="hasError" variant="warning">
          {{ errorMessage }}
        </b-alert>

        <p>Die Einladung geht an folgende E-Mail-Adresse:</p>
        <validation-observer ref="observer" v-slot="{ passes }">
          <b-form @submit.prevent="passes(onSubmit)" class="mt-2">

            <validation-provider vid="email" rules="required|email" v-slot="{ valid, errors, changed }">
              <b-form-group id="input-group-email" label-for="input-email">
                <b-form-input
                  v-model="mailAddress"
                  :state="onValidateField(valid, errors, changed)"
                  type="email"
                  placeholder="E-Mail angeben"
                ></b-form-input>
                <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <p>Falls Sie keine E-Mail-Adresse haben vom Eigentümer, holen Sie eine Vollmacht ein und signieren Sie digital selbst.</p>
            <b-button type="submit" class="btn btn-green mt-3" disabled v-if="isSubmitting">
              <b-spinner small></b-spinner>
              Senden
            </b-button>
            <b-button type="submit" class="btn btn-green mt-3" v-else>Senden</b-button>
          </b-form>
        </validation-observer>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import { validateField } from '@/helpers/formHelper.js'

  export default {
    data: () => ({
      status: false,
      isSubmitting: false,
      hasUnknownError: false,
      hasError: false,
      unknownErrorMessage: '',
      errorMessage: '',
      mailAddress: null
    }),
    props: {
      ownersMail: {
        type: String
      },
      gesuchId: {
        type: Number
      }
    },
    components: {
      ValidationObserver,
      ValidationProvider
    },
    methods: {
      onSubmit () {
        this.isSubmitting = true
        this.hasUnknownError = false
        this.hasError = false
        this.errorMessage = ''
        this.$store.dispatch('permission/CREATE_SIGNATURE_PERMISSION', {
          formData: this.mailAddress,
          applicationId: this.gesuchId
        }).then(res => {
          const { errors } = res
          if (errors) {
            if (errors[0].extensions && errors[0].extensions.code === 'EMAIL_HAS_ALREADY_ACCESS') {
              this.hasError = true
              this.errorMessage = 'Diese E-Mailadresse hat bereits Zugang zu diesem Gesuch'
              this.isSubmitting = false
              setTimeout(() => {
                this.hasError = false
              }, 3000)
            } else {
              this.hasUnknownError = true
              this.unknownErrorMessage = this.$t('formError.unknownwError')
              this.isSubmitting = false
              setTimeout(() => {
                this.hasUnknownError = false
              }, 3000)
            }
          } else {
            this.isSubmitting = false
            this.$refs.ownersModal.hide()
            this.mailAddress = this.ownersMail
            this.$emit('refresh-application-redirected')
            this.$root.$emit('showRedirectNotification')
          }
        }).catch(err => {
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          this.isSubmitting = false
          console.error(err)
        })
      },
      openModal () {
        this.$refs.ownersModal.show()
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      }
    },
    watch: {
      ownersMail (newValue, oldValue) {
        this.mailAddress = newValue
      }
    }
  }
</script>

<style lang="scss">
#modal-owners-digital-application {
  padding-left: 0 !important;

  .magenta-title {
    color: $magenta;
    font-weight: $font-weight-bold;
  }
}
</style>
